// extracted by mini-css-extract-plugin
export default {"tryOn":"TryOnOnOnboarding_tryOn__v20hi","tryOn__button":"TryOnOnOnboarding_tryOn__button__fGzBx"};